<template>
    <div>
        <el-row :gutter="10">
            <el-col :span="15">
                <el-input v-model="searchObj.keywords">
                    <el-select slot="prepend" :value="0" style="width:200px;">
                        <el-option :value="0" label="账号或者用户名称"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="getList(1)"></el-button>
                </el-input>
                <vxe-table :data="tableData" border :loading="loading" style="margin-top:10px;" :row-config="{ isCurrent: true, isHover: true }" @current-row-change="currentRowChange">
                    <vxe-column field="userName" title="账号" width="250"></vxe-column>
                    <vxe-column field="name" title="用户名称"></vxe-column>
                    <vxe-column field="phone" title="手机"></vxe-column>
                    <vxe-column field="companyName" title="公司名称"></vxe-column>
                    <vxe-column field="insertTime" title="注册时间"></vxe-column>
                </vxe-table>
                <vxe-pager align="left" @page-change="getList" :page-size.sync="searchObj.pageSize" :current-page.sync="searchObj.currentPage" :total="searchObj.total" :layouts="['PrevPage', 'Jump', 'PageCount', 'NextPage', 'Total']">
                </vxe-pager>
            </el-col>
            <el-col :span="9" style="line-height:50px;" v-loading="saveloading">
                <el-divider>{{ currentRow.userName }}</el-divider>
                <el-checkbox label="WXCW_DaoRu" v-model="userPermission.wxcW_DaoRu">测温仪导入数据权限</el-checkbox>
                <el-row type="flex" justify="end"><el-button type="primary" @click="saveUserPermission">保存</el-button></el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            saveloading: false,
            tableData: [],
            searchObj: {
                keywords: "",
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            currentRow: {},
            userPermission: {}
        };
    },
    methods: {
        saveUserPermission() {
            let that = this;
            that.saveloading = true;
            that.axios.post("Sys_UserPermission/SaveUserPermission", that.userPermission).then((response) => {
                that.saveloading = false;
                if (response.data.code == 101) {

                    that.$message.success("保存成功");
                }
            }).catch(ex => {
                that.saveloading = false;
                that.$message.error(ex);
            });
        },
        currentRowChange({ newValue }) {
            let that = this;
            that.currentRow = newValue;
            that.axios.post("Sys_UserPermission/GetUserPermission", { OnlyInt: that.currentRow.id }).then((response) => {
                that.userPermission = response.data.data;
            });
        },
        getList() {
            let that = this;
            that.loading = true;
            that.axios.post("Sys_UserInfo/GetList1", that.searchObj).then((response) => {
                that.tableData = response.data.data.data;
                that.searchObj.total = response.data.data.total;
                that.loading = false;
            });
        },
        search() {
            let that = this;
            that.searchObj.currentPage = 1;
            that.getList();
        }
    },
    mounted() {
        let that = this;
        that.getList();
    }
};
</script>

<style></style>